export const PERMS = {
    READ: 'report_cost_center_cost.read',
    EXPORT: 'report_cost_center_cost.export',
}
